module.exports = __webpack_public_path__ + "img/scan_code_active.f7b5ba01.svg";